'use client';

import dynamic from 'next/dynamic';

const FintechConsole = dynamic(() => import('@/components/console/FintechConsole'), {
  ssr: false,
  loading: () => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100dvh', width: '100%', background: '#0d1424', color: '#7b8494', fontFamily: 'system-ui, sans-serif', fontSize: 13 }}>
      Loading console…
    </div>
  ),
});

export default function Home() {
  return <FintechConsole />;
}
